import React, { useContext } from "react";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../app/stores/rootStore";
import { ISurveyResult } from "../../app/models/dto";
import SurveyShareButton from "../buttons/SurveyShareButton";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../../app/localization/localization";

export interface SurveyParams {
  surveyId: number;
  surveyResultDetails: ISurveyResult;
}

const AnswerToolbar: React.FC<SurveyParams> = ({
  surveyId,
  surveyResultDetails,
}) => {
  const rootStore = useContext(RootStoreContext);
  const { theme } = rootStore.commonStore;
  const { view } = rootStore.surveyStore;
  const [t] = useTranslation(["surveys"], translationHookOptions);

  return (
    <div>
      <div
        className={classnames(
          "surveyContentTitle d-inline-flex ",
          `${theme!.titleBarBgSurvey} ${theme!.titleBarTextSurvey}`
        )}
      >
        <b className="surveyContentTitleText">{t("answer_toolbar_bar_text")}</b>
        <div className="ml-auto surveyContentButtonContainer">
          {view === "vote" ? (
            <SurveyShareButton
              surveyId={surveyId}
              permissions={surveyResultDetails.permissions}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default observer(AnswerToolbar);
